export default __webpack_public_path__ + "images/docx_32.png";